import React, {useEffect, useMemo} from "react";
import {
    Autocomplete,
    BringDataIcon,
    Button,
    Dialog,
    FilterRemoveIcon,
    Heading,
    IconButton,
    InfoSignIcon,
    NewLayerIcon,
    Pagination,
    Pane, Paragraph,
    RemoveIcon,
    SearchInput,
    Select,
    SortDescIcon,
    SortIcon,
    Table,
    toaster,
    Tooltip,
    UpdatedIcon
} from "evergreen-ui";
import {useDispatch, useSelector} from "react-redux";
import {
    decadeConstructor,
    selectorStationsForFilters,
    temporaryTurnSelector,
    useCreateFilterMutation
} from "../Constructor/periodValuesFilterApi";
import {saveTemplate} from "../Constructor/decadeConstructor/ApiCalls";
import {initTemplates, removeTemplate} from "./OutputFormsSlice";
import {selectOFTemplates} from "./OutputFormsSelectors";
import {deleteTemplate, findTemplateById, findTemplates, packConstructorDataInObject} from "./ApiCalls";
import FullTemplateInfoDialog from "./dialogs/FullTemplateInfoDialog";
import {setNewDecadeConstructor, setNewTTConstructor} from "../Constructor/constructorSlice";
import {defaultConstructor, evaporationConstructor} from "../Constructor/common/constructorObject";
import CreateDecadeOutputFormDialog from "../Constructor/decadeConstructor/CreateOutputFormDialog";
import CreateOutputFormTTDialog from "../Constructor/temporaryTurnConstructor/CreateOutputFormTTDialog";
import {createTemplate} from "../Constructor/temporaryTurnConstructor/ApiCalls";
import CreateOutputFormRainFloodDialog from "../Constructor/rainFlood/CreateOutputFormRainFloodDialog";
import {setNewRainFloodConstructor} from "../Constructor/rainFlood/rainFloodSlice";
import {getTemplatesRights} from "../Privileges/PrivilegesSelectors";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import CreateViaTemplateDialog from "./dialogs/CreateViaTemplateDialog";
import CreateTemplateDialog from "../Constructor/common/CreateTemplateDialog";
import SmartButton from "../Constructor/common/SmartButton";
import {floodObject} from "../Constructor/flood/model/FloodObjects";
import {setNewRiverFloodConstructor} from "../Constructor/riverFlood/riverFloodSlice";
import {saveRainTemplate, saveRiverTemplate} from "../Constructor/rainFlood/ApiCalls";
import CreateOutputFormRiverFloodDialog from "../Constructor/riverFlood/CreateOutputFormRiverFloodDialog";
import CoefficientsComponent, {checkCoefficients} from "../Constructor/flood/common/CoefficientsComponent";
import CreateOutputFormEvaporationDialog from "../Constructor/evaporation/CreateOutputFormEvaporationDialog";
import {setNewEvaporationConstructor} from "../Constructor/evaporation/evaporationSlice";
import {saveEvapTemplate} from "../Constructor/evaporation/api/ApiCalls";
import {AutoCompleteMaterials} from "../BaseMaterials/BaseMaterials";

export default function OutputFormsTable() {
    const dispatch = useDispatch();
    const privileges = useSelector(state => state.login.privileges)
    const rights = getTemplatesRights(privileges);

    const [saveFilter] = useCreateFilterMutation();

    const ttConstructor = useSelector(temporaryTurnSelector);
    const decConstructor = useSelector(decadeConstructor);
    const rfConstructor = useSelector(state => state.rainFloodConstructor)
    const riverConstructor = useSelector(state => state.riverFloodConstructor)
    const evapConstructor = useSelector(state => state.evaporationConstructor)

    const stations = useSelector(selectorStationsForFilters);
    const templates = useSelector(selectOFTemplates) || []

    const [type, setType] = React.useState('')
    const [stn, setStn] = React.useState('')
    const [name, setName] = React.useState('')

    const [shouldUpdate, setShouldUpdate] = React.useState(false)


    const lastSortEnum = {
        NAME: "NAME",
        STATION: "STATION",
        CONSTRUCTOR_TYPE: "CONSTRUCTOR_TYPE",
        USER: "USER",
        CREATION_DATE: "CREATION_DATE",
        CHANGE_DATE: "CHANGE_DATE",
    }


    const [lastSort, setLastSort] = React.useState(lastSortEnum.CREATION_DATE)
    const [lastOrder, setLastOrder] = React.useState(false)

    const [resortTemplateName, setResortTemplateName] = React.useState(true)
    const [resortStationName, setResortStationName]   = React.useState(true)
    const [resortUser, setResortUser]   = React.useState(true)
    const [resortConstructorType, setResortConstructorType]   = React.useState(true)
    const [resortCreationDate, setResortCreationDate]   = React.useState(false)
    const [resortChangeDate, setResortChangeDate]   = React.useState(false)
    const [isFetch, setIsFetch] = React.useState(false)
    const [lastRequestFilters, setLastRequestFilters] = React.useState(new Map())
    const [elementsPerPage, setElementsPerPage] = React.useState(10)


    function sort(asc, sort) {
        setLastOrder(asc)
        setLastSort(sort)

        findTemplates(lastRequestFilters, sort, asc).then(
            (res) => {
                dispatch(initTemplates(res.data.content))
                setCurPage(res.data.pageable.pageNumber + 1)
                setTotalPages(res.data.totalPages)
                setIsFetch(false)
            }
        )
        setIsFetch(false)
    }

    function clearFilter() {
        setType('')
        setName('')
        setStn('')
        setShouldUpdate(!shouldUpdate)
    }

    function getFilters() {
        let filters = new Map();
        if (stn.length !== 0) {
            filters.set('stn', stn)
        }
        if (type.length !== 0) {
            filters.set('type', type)
        }

        if (name.length !== 0) {
            filters.set('name', name)
        }
        filters.set('pageNum', (curPage - 1))
        filters.set('elsPerPage', elementsPerPage)

        return filters
    }

    function changeElementsPerPage(number) {
        setCurPage(1)
        setElementsPerPage(number)
        setShouldUpdate(!shouldUpdate)
    }

    function updateTemplates() {
        setIsFetch(true)
        const filters = getFilters()
        setLastRequestFilters(filters)
        findTemplates(filters, lastSort, lastOrder).then(
            (res) => {
                dispatch(initTemplates(res.data.content))
                setCurPage(res.data.pageable.pageNumber + 1)
                setTotalPages(res.data.totalPages)
                setIsFetch(false)
            }
        )
        setIsFetch(false)
    }

    useMemo(() => {
        switch (lastSort) {
            case lastSortEnum.NAME:
                sort(resortTemplateName, lastSortEnum.NAME)
                break
            case lastSortEnum.USER:
                sort(resortUser, lastSortEnum.USER)
                break
            case lastSortEnum.STATION:
                sort(resortStationName, lastSortEnum.STATION)
                break
            case lastSortEnum.CONSTRUCTOR_TYPE:
                sort(!resortConstructorType, lastSortEnum.CONSTRUCTOR_TYPE)
                break
            case lastSortEnum.CREATION_DATE:
                sort(resortCreationDate, lastSortEnum.CREATION_DATE)
                break
            case lastSortEnum.CHANGE_DATE:
                sort(resortChangeDate, lastSortEnum.CHANGE_DATE)
                break
        }
    }, [resortTemplateName, resortStationName, resortConstructorType, resortCreationDate, resortChangeDate, resortUser])

    useEffect(() => {
            setIsFetch(true)
            updateTemplates()
            setIsFetch(false)
        },
        [shouldUpdate])

    function onFilterPress(e)  {
        if (e.key === 'Enter') {
            onUpdate()
        }
    }

    function onUpdate() {
        setCurPage(1)
        setShouldUpdate(!shouldUpdate)
    }

    const [constructorType, setConstructorType] = React.useState()
    const [isFullInfoWindowShow, setIsFullInfoWindowShow] = React.useState(false)
    const [isCreateViaTemplateWindowShow, setIsCreateViaTemplateWindowShow] = React.useState(false)
    const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
    const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

    const [curPage, setCurPage] = React.useState(1)
    const [totalPages, setTotalPages] = React.useState(0)

    const [isDecadeWindowShown, setIsDecadeWindowShown] = React.useState(false)
    const [isRainFloodWindowShown, setIsRainFloodWindowShown] = React.useState(false)
    const [isRiverFloodWindowShown, setIsRiverFloodWindowShown] = React.useState(false)
    const [isTTWindowShown, setIsTTWindowShown] = React.useState(false)
    const [isEvapWindowShown, setIsEvapWindowShown] = React.useState(false)
    const [isRemoveWindowShown, setIsRemoveWindowShown] = React.useState(false)
    const [templateId, setTemplateId] = React.useState()
    const [templateName, setTemplateName] = React.useState()
    const [removeTemplateId, setRemoveTemplateId] = React.useState()

    const setDecadeShownCallback = (shown) => setIsDecadeWindowShown(shown)
    const setTTShownCallback = (shown) => setIsTTWindowShown(shown)
    const setRainFloodShownCallback = (shown) => setIsRainFloodWindowShown(shown)
    const setRiverFloodShownCallback = (shown) => setIsRiverFloodWindowShown(shown)
    const setEvapShownCallback = (shown) => setIsEvapWindowShown(shown)

    function onRemoveTemplate(id) {
        deleteTemplate(id).then( (res) => {
                dispatch(removeTemplate(removeTemplateId))
                toaster.success("Успешно удалили!")
                setShouldUpdate(!shouldUpdate)
                setIsRemoveWindowShown(false)
        }).catch((error) => {
               if (error.response) {
                   if (error.response.status === 400) {
                       toaster.danger("Нельзя удалить данный шаблон, т.к. одна или несколько выходных форм " +
                           "по-прежнему ссылаются на него.")
                   } else {
                       toaster.danger("Не удалось удалить шаблон. Возможно он уже был удален. " +
                           "Попробуйте обновить страницу")
                   }
               }

        })
    }

    function openRemoveWindow(templateId) {
        setRemoveTemplateId(templateId)
        setIsRemoveWindowShown(true)
    }

    function setConstructor(res) {
        const constructorData = packConstructorDataInObject(res.data)
        setConstructorType(constructorData.type)
        switch (constructorData.type) {
            case "DECADE":
                dispatch(setNewDecadeConstructor(constructorData));
                break;
            case "TT":
                dispatch(setNewTTConstructor(constructorData));
                break;
            case "RAIN_FLOOD":
                dispatch(setNewRainFloodConstructor(constructorData))
                break;
            case "RIVER_FLOOD":
                dispatch(setNewRiverFloodConstructor(constructorData))
                break;
            case "EVAPORATION":
                dispatch(setNewEvaporationConstructor(constructorData))
                break;
        }
    }


    function openFullInfoWindow(templateId, templateType) {
        findTemplateById(templateId, templateType).then(
            (res) => {
                setConstructor(res)
                setIsFullInfoWindowShow(true)
            }
        )
    }

    function openCreateViaTemplateWindow(templateId, templateType) {
        findTemplateById(templateId, templateType).then(
            (res) => {
                setConstructor(res)
                setIsCreateViaTemplateWindowShow(true)
            }
        )
    }

    function changePage(page) {
        setCurPage(page)
        setShouldUpdate(!shouldUpdate)
    }

    function showGenerateOutputFormWindow(type, templateId, name) {
        setTemplateId(templateId)
        setTemplateName(name)
        switch (type.trim()) {
            case "DECADE":
                setIsDecadeWindowShown(true)
                break;
            case "TT":
                setIsTTWindowShown(true)
                break;
            case "RAIN_FLOOD":
                setIsRainFloodWindowShown(true)
                break;
            case "RIVER_FLOOD":
                setIsRiverFloodWindowShown(true)
                break;
            case "EVAPORATION" :
                setIsEvapWindowShown(true)
                break;
        }
    }

    function onCloseFullInfo(type) {
        switch (type.trim()) {
            case "DECADE":
                dispatch(setNewDecadeConstructor({...defaultConstructor}))
                break;
            case "TT":
                dispatch(setNewTTConstructor({...defaultConstructor}))
                break;
            case "RAIN_FLOOD":
                dispatch(setNewRainFloodConstructor({...floodObject}))
                break;
            case "RIVER_FLOOD":
                dispatch(setNewRiverFloodConstructor({...floodObject}))
                break;
            case "EVAPORATION":
                dispatch(setNewEvaporationConstructor({...evaporationConstructor}))
        }
        setShouldUpdate(!shouldUpdate)
        setIsCreateViaTemplateWindowShow(false)
        setIsFullInfoWindowShow(false)
    }

    function checkAllFieldSet() {
        if (constructorType === "DECADE") {
            // if (decConstructor.decadeOperations.length === 0) {
            //     toaster.danger("Декадные операции не установлены")
            //     return false;
            // }
            if (decConstructor.tableOperations.length === 0) {
                toaster.danger("Операции для таблицы не установлены")
                return false;
            }


            for (let i = 0; i < decConstructor.filtersRows.length; i++) {
                if (decConstructor.filtersRows[i].operation === "") {
                    toaster.danger("Операция для фильтра №" + (i+1) + " не установлена")
                    return false
                }
            }
        }
        if (constructorType === "TT") {
            if (ttConstructor.tableOperations.length === 0) {
                toaster.danger("Операции для таблицы не установлены")
                return false;
            }


            for (let i = 0; i < ttConstructor.filtersRows.length; i++) {
                if (ttConstructor.filtersRows[i].code.id === -1) {
                    toaster.danger("Код для фильтра №" + (i+1) + " не установлен")
                    return false
                }
            }
        }

        if (constructorType === "EVAPORATION") {
        }

        return true
    }

    function checkConstructorsCoefficients(constructor) {
        if (constructor === decConstructor
            || constructor === ttConstructor
            || constructor === evapConstructor) {
            return true
        }

        return checkCoefficients(
            constructor.coefficients,
            constructor.equation
        );
    }

    function createTemplateFunction(constructor, templateName) {
        switch (constructorType) {
            case "DECADE":
                saveTemplate(decConstructor, saveFilter, templateName)
                break;
            case "TT":
                createTemplate(ttConstructor, templateName)
                break;
            case "RAIN_FLOOD":
                saveRainTemplate(rfConstructor, templateName)
                break
            case "RIVER_FLOOD":
                saveRiverTemplate(riverConstructor, templateName)
                break;
            case "EVAPORATION":
                saveEvapTemplate(evapConstructor, templateName)
                break;
        }
        setShouldUpdate(!shouldUpdate)
        setCreateTemplateShown(false)
    }

    function isCreateTTTemplateDisabled() {
        return ttConstructor.filtersRows[ttConstructor.filtersRows.length-1].code.id === -1
    }

    function isCreateDecTemplateDisabled() {
        return decConstructor.filtersRows[decConstructor.filtersRows.length-1].code.id == -1
    }

    function isCreateFloodTemplateDisabled(ctr) {
        const filtersNum = ctr.filters.length - 1

        return ctr.station.id === -1 || ctr.filters[filtersNum].level.stnEntity.id === -1 ||
            ctr.filters[filtersNum].rainfall.stnEntity.id === -1 ||
            ctr.equation === "" ||
            ctr.catchmentArea === ""
    }

    function isCreateEvapTemplateDisabled() {
        return false
    }

    function isCreateTemplateDisabled() {
        if (constructorType === "DECADE") return isCreateDecTemplateDisabled()
        if (constructorType === "TT") return isCreateTTTemplateDisabled()
        if (constructorType === "RIVER_FLOOD") return isCreateFloodTemplateDisabled(riverConstructor)
        if (constructorType === "RAIN_FLOOD") return isCreateFloodTemplateDisabled(rfConstructor)
        if (constructorType === "EVAPORATION") return isCreateEvapTemplateDisabled(rfConstructor)

        return true
    }

    return (
        <Pane height={320 +  templates.length * 40}>
            <Pane marginTop={40}>
                <Pane marginLeft={40}>
                    <Heading size={600}>Шаблоны выходных форм</Heading>
                </Pane>
                <Pane
                    display="flex"
                    marginTop={10}
                    marginLeft={40}
                    marginBottom={20}
                    columnGap={12}
                    gridTemplateRows="max-content max-content"
                    gridRowGap=".5em"
                    alignItems="center"
                >
                    <SearchInput
                        placeholder="Название шаблона..."
                        onKeyPress={(e) => onFilterPress(e)}
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                    <Pane>
                        {AutoCompleteMaterials(setStn, stations, stn, onFilterPress)}
                    </Pane>
                    <Pane>
                        <Select value={type === 'DECADE' ?
                            0 :
                            type === 'TT' ?
                                1 :
                                type === "RAIN_FLOOD" ?
                                    2 :
                                    type === "RIVER_FLOOD" ?
                                        3 :
                                        type === "EVAPORATION" ?
                                            4 :
                                            -1}
                                onChange={e => setType(e.target.value == 0 ?
                                    'DECADE': e.target.value == 1 ?
                                        'TT' : e.target.value == 2 ?
                                        'RAIN_FLOOD' : e.target.value == 3 ?
                                        'RIVER_FLOOD' : e.target.value == 4 ?
                                        'EVAPORATION' : '')}
                        >
                            <option value={-1}>Тип конструктора</option>
                            <option value={0}>Суточные, декадные, месячные значения</option>
                            <option value={1}>Временной ход</option>
                            <option value={2}>Дождевые паводки</option>
                            <option value={3}>Половодье</option>
                            <option value={4}>Наблюдение испарения</option>
                        </Select>
                    </Pane>

                    <Tooltip content="Обновить">
                        <IconButton icon={UpdatedIcon} onClick={() => onUpdate()}/>
                    </Tooltip>
                    <Tooltip content="Сбросить">
                        <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                    </Tooltip>
                </Pane>
            </Pane>

            <Pane marginLeft={40} marginRight={40} marginBottom={40}>
                <Pane>
                    {isFetch? <SuspenseSpinner/> : <Table>
                        <Table.Head >
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortTemplateName(!resortTemplateName); setLastSort(lastSortEnum.NAME)}} rightView={resortTemplateName ? <SortIcon/> : <SortDescIcon/>}>
                                Название шаблона
                            </Table.TextHeaderCell>
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortStationName(!resortStationName); setLastSort(lastSortEnum.STATION)}} rightView={resortStationName ? <SortIcon/> : <SortDescIcon/>}>
                                Станция
                            </Table.TextHeaderCell>
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortConstructorType(!resortConstructorType); setLastSort(lastSortEnum.CONSTRUCTOR_TYPE)}} rightView={resortConstructorType ? <SortIcon/> : <SortDescIcon/>}>
                                Тип конструктора
                            </Table.TextHeaderCell>
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortCreationDate(!resortCreationDate); setLastSort(lastSortEnum.CREATION_DATE)}} rightView={resortCreationDate ? <SortIcon/> : <SortDescIcon/>}>
                                Дата создания
                            </Table.TextHeaderCell>
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortChangeDate(!resortChangeDate); setLastSort(lastSortEnum.CHANGE_DATE)}} rightView={resortChangeDate ? <SortIcon/> : <SortDescIcon/>}>Дата изменения</Table.TextHeaderCell>
                            <Table.TextHeaderCell isSelectable onClick={() => {setResortUser(!resortUser); setLastSort(lastSortEnum.USER)}} rightView={resortUser ? <SortIcon/> : <SortDescIcon/>}>Пользователь</Table.TextHeaderCell>
                            <Table.TextHeaderCell flexBasis={105}>Меню</Table.TextHeaderCell>
                        </Table.Head>
                        <Table.VirtualBody height={templates.length * 40} >
                            {templates.map((t) => (
                                <Table.Row key={t.id} height={40}>
                                    <Table.TextCell>{t.name}</Table.TextCell>
                                    <Table.TextCell>{t.stationName}</Table.TextCell>
                                    <Table.TextCell>{t.formType}</Table.TextCell>
                                    <Table.TextCell>{t.createDate}</Table.TextCell>
                                    <Table.TextCell>{t.updateDate}</Table.TextCell>
                                    <Table.TextCell>{t.author ? t.author : ""}</Table.TextCell>
                                    <Table.Cell gap={5} flexBasis={105}>
                                        {
                                            rights.canCreateOutputForm ?
                                                <Tooltip content="Сформировать выходную форму">
                                                    <IconButton
                                                        marginRight={20}
                                                        icon={BringDataIcon}
                                                        onClick={() => showGenerateOutputFormWindow(t.typeName, t.reportId, t.stationName)}
                                                    />
                                                </Tooltip>
                                            : <></>
                                        }
                                        {
                                            rights.canShowInDetails ?
                                                <Tooltip content="Посмотреть детально">
                                                    <IconButton icon={InfoSignIcon} onClick={() => openFullInfoWindow(t.reportId, t.typeName)}/>
                                                </Tooltip>
                                            : <></>
                                        }
                                        {
                                            rights.canShowInDetails ?
                                                <Tooltip content="Создать по образцу">
                                                    <IconButton icon={NewLayerIcon} onClick={() => openCreateViaTemplateWindow(t.reportId, t.typeName)}/>
                                                </Tooltip>
                                                : <></>
                                        }
                                        {
                                            rights.canRemove ?
                                                <Tooltip content="Удалить">
                                                    <IconButton icon={RemoveIcon} onClick={() => openRemoveWindow(t.reportId)}/>
                                                </Tooltip>
                                            : <></>
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.VirtualBody>
                    </Table>}
                </Pane>
                <Pane display={"flex"} alignItems={"center"} justifyContent={"center"} margin={10}>
                    <Pagination page={curPage}
                                totalPages={totalPages}
                                onPageChange={(page) => changePage(page)}
                                onNextPage={() => changePage(curPage + 1)}
                                onPreviousPage={() => changePage(curPage - 1)}
                    />
                </Pane>
                <Pane justifyContent={"right"} verticalAlign={"right"} display={"flex"} marginRight={40} marginTop={-37}>
                    <Paragraph>Показывать по</Paragraph>
                    <Pane>
                        <Select value={elementsPerPage} onChange={event => changeElementsPerPage(event.target.value)} marginLeft={10}>
                            <option value={"5"}>5</option>
                            <option value={"10"}>10</option>
                            <option value={"15"}>15</option>
                            <option value={"20"}>20</option>
                        </Select>
                    </Pane>

                </Pane>

                <CreateDecadeOutputFormDialog
                    constructor={decConstructor}
                    isShown={isDecadeWindowShown}
                    setIsShown={setDecadeShownCallback}
                    viaTemplateId={true}
                    id={templateId}
                    name={templateName}
                />

                <CreateOutputFormTTDialog
                    constructor={ttConstructor}
                    isShown={isTTWindowShown}
                    setIsShown={setTTShownCallback}
                    viaTemplateId={true}
                    id={templateId}
                    name={templateName}
                />

                <CreateOutputFormRainFloodDialog
                    constructor={rfConstructor}
                    isShown={isRainFloodWindowShown}
                    setIsShown={setRainFloodShownCallback}
                    viaTemplateId={true}
                    id={templateId}
                    name={templateName}
                />

                <CreateOutputFormRiverFloodDialog
                    constructor={riverConstructor}
                    isShown={isRiverFloodWindowShown}
                    setIsShown={setRiverFloodShownCallback}
                    viaTemplateId={true}
                    id={templateId}
                    name={templateName}
                />

                <CreateOutputFormEvaporationDialog
                    constructor={evapConstructor}
                    isShown={isEvapWindowShown}
                    setIsShown={setEvapShownCallback}
                    viaTemplateId={true}
                    id={templateId}
                    name={templateName}
                />

                <Pane>
                    <Dialog
                        isShown={isRemoveWindowShown}
                        title="Удаление шаблона"
                        intent="danger"
                        onConfirm={() => onRemoveTemplate(removeTemplateId)}
                        onCloseComplete={() => setIsRemoveWindowShown(false)}
                        confirmLabel="Удалить"
                        cancelLabel="Отменить"
                    >
                        Вы действительно хотите удалить данный шаблон?
                    </Dialog>
                </Pane>
                <Pane marginTop={5} marginBottom={10}>
                    <Dialog
                        shouldCloseOnOverlayClick={false}
                        shouldCloseOnEscapePress={false}
                        width={1400}
                        isShown={isFullInfoWindowShow}
                        title="Информация о шаблоне"
                        onCloseComplete={() => onCloseFullInfo(constructorType)}
                        hasFooter={false}
                    >
                        <FullTemplateInfoDialog constructorType={constructorType}/>
                    </Dialog>
                </Pane>
                <Pane marginTop={5} marginBottom={10}>
                    <Dialog
                        shouldCloseOnOverlayClick={false}
                        shouldCloseOnEscapePress={false}
                        width={1400}
                        isShown={isCreateViaTemplateWindowShow}
                        title="Создать по образцу"
                        onCloseComplete={() => onCloseFullInfo(constructorType)}
                        footer={
                            <Pane>
                                <Button marginRight={5} onClick={() => {
                                    setIsCreateViaTemplateWindowShow(false)
                                }}>Отменить</Button>

                                <SmartButton
                                    disabledTooltip={"Выберите фильтры"}
                                    buttonText={"Создать"}
                                    isPrimary={true}
                                    isDisabled={isCreateTemplateDisabled()}
                                    onClickAction={() => {
                                        //Вообще, наверное, лучше бы сразу вверху при определении типа конструктора его
                                        // хранить в единой переменной. Но сейчас нет времени на эксперименты :)
                                        let currentConstructor = null;
                                        switch (constructorType) {
                                            case "DECADE":
                                                currentConstructor = decConstructor;
                                                break;
                                            case "TT":
                                                currentConstructor = ttConstructor;
                                                break;
                                            case "RAIN_FLOOD":
                                                currentConstructor = rfConstructor;
                                                break;
                                            case "RIVER_FLOOD":
                                                currentConstructor = riverConstructor;
                                                break;
                                            case "EVAPORATION":
                                                currentConstructor = evapConstructor;
                                                break;
                                        }
                                        if (checkAllFieldSet()
                                            && checkConstructorsCoefficients(currentConstructor)
                                        ) {
                                            setCreateTemplateShown(true);
                                        }
                                    }}
                                />
                            </Pane>
                        }
                    >
                        <CreateViaTemplateDialog constructorType={constructorType}/>
                    </Dialog>
                </Pane>

                <CreateTemplateDialog isShown={createTemplateShown}
                                      setIsShown={setCreateTemplateShownCallback}
                                      createTemplate={(templateName) => createTemplateFunction(decConstructor, templateName)}
                />

            </Pane>
        </Pane>
    );
}